import * as React from "react";
const SvgLightning = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 30, viewBox: "0 0 18 30", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 12.4105H11.5109L13.4674 0L0 17.5895H6.48913L4.53261 30L18 12.4105Z", fill: "#4D5154" }));
export default SvgLightning;
